import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  organizationsPage: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }
}));

export default useStyles;
